
import { Component, Vue, Watch } from 'vue-property-decorator';
import {
  Client,
  IJobItemModel,
  JobItemScheduleModel,
  IJobItemScheduleModel,
  EmployeeModel,
  JobItemType,
  IJobItemScheduleAssignEmployeeModel,
  JobItemScheduleAssignEmployeeModel
} from '@/services/api.service';
import { EventBus } from '@/event-bus';
import { JobItemScheduleAssignmentUpdatedMessage } from '@/services/eventbus.models';

import * as StringUtils from '@/utilities/string.utils';

@Component({
  props: {
    jobItemSchedule: {
      type: Object as () => IJobItemScheduleModel,
      required: true
    },
    isInDialogMode: Boolean
  }
})
export default class AssignEmployee extends Vue {
  private assignableEmployees: EmployeeModel[] = [];
  private assignToEmployeeGid: string = '';

  
  private mounted() {
    this.updateAssignableEmployees(this.$props.jobItemSchedule.jobItemType);
  }

  private updateAssignableEmployees(jobItemType: JobItemType) {
    
    const currentEmployeeGid = this.$props.jobItemSchedule.assignedToEmployeeGid;
    console.log('Current Employee:' + currentEmployeeGid);

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    const vm = this;
    this.assignableEmployees = [];
    const employees = clientService.getAssignableEmployees(jobItemType as any).then(data => {
      const sortedData = data.sort((n1, n2) => StringUtils.stringCompare(n1.firstName || '', n2.firstName || ''));
      const assignableEmployeesPlaceholder = new EmployeeModel();
      assignableEmployeesPlaceholder.init({ firstName: '(Select Employee...)', lastName: '', gid: '' });
      sortedData.unshift(assignableEmployeesPlaceholder);

      vm.assignableEmployees = sortedData;
      console.log('Current Employee:' + currentEmployeeGid);
      if (vm.assignableEmployees.filter(e => e.gid === currentEmployeeGid).length !== 0) {
        console.log('Current Employee found');
        vm.assignToEmployeeGid = currentEmployeeGid;
      } else {
        console.log('Current Employee NOT found');
        vm.assignToEmployeeGid = assignableEmployeesPlaceholder.gid!;
      }
    });
  }

  private unassignEmployee() {
    const me = this;

    const jobGid: string = this.$props.jobItemSchedule.jobGid;
    const jobItemGid: string = this.$props.jobItemSchedule.jobItemGid;
    const jobItemScheduleGid: string = this.$props.jobItemSchedule.jobItemScheduleGid;

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    // @ts-ignore
    this.$Progress.start();
    clientService.unassignScheduledJobItem(jobGid, jobItemGid, jobItemScheduleGid).then(data => {
      // @ts-ignore
      this.$Progress.finish();
      // @ts-ignore
      this.$awn.success('Job task ' + me.$props.jobItemSchedule.jobItemNumber + ' unassigned successfully');
      this.$emit('schedule-assignment-updated', data);
      EventBus.$emit('schedule-assignment-updated', new JobItemScheduleAssignmentUpdatedMessage(data));
      this.closeModal();
    });
  }


  private updateAssignment() {
    const me = this;

    const jobGid: string = this.$props.jobItemSchedule.jobGid;
    const jobItemGid: string = this.$props.jobItemSchedule.jobItemGid;
    const jobItemScheduleGid: string = this.$props.jobItemSchedule.jobItemScheduleGid;

    const assignModel: IJobItemScheduleAssignEmployeeModel = {
      jobItemGid: this.$props.jobItemSchedule.jobItemGid,
      jobItemScheduleGid: this.$props.jobItemSchedule.jobItemScheduleGid,
      assignToEmployeeGid: this.assignToEmployeeGid
    };

    const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);
    // @ts-ignore
    this.$Progress.start();
    clientService.assignScheduledJobItem(jobGid, jobItemGid, jobItemScheduleGid, new JobItemScheduleAssignEmployeeModel(assignModel)).then(data => {
      // @ts-ignore
      this.$Progress.finish();
      // @ts-ignore
      this.$awn.success('Job task ' + me.$props.jobItemSchedule.jobItemNumber + ' assigned successfully');
      this.$emit('schedule-assignment-updated', data);
      EventBus.$emit('schedule-assignment-updated', new JobItemScheduleAssignmentUpdatedMessage(data));
      this.closeModal();
    });
  }

  private cancelEdit() {
    console.log('Cancelling edit...');
    this.closeModal();
  }

  private closeModal() {
    if (this.$props.isInDialogMode) {
      this.$modal.hide('modal-schedule-assign-employee');
    }
  }
}
